export enum LikeStatus {
    Initial,
    Like,
    Dislike
}
